/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this file will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  /*
   * 購入オプション（Subscribe & Save / One-time）まわりの補正。
   *
   * 前提: 選択状態を決めているのはサーバー。ラジオを変えると theme が
   * $sectionApi.navigate() でセクションHTMLを取り直し、返ってきたHTMLの
   * price / CTA / ラジオの checked 属性で状態が確定する。この往復は非同期。
   *
   * この仕組みに2つの穴があり、どちらも「画面の表示」と「実際にカートに入るもの」が
   * ズレる。
   *
   *   A. 往復中に別の選択をすると、後から着地した描画が先の選択を上書きする。
   *      → One-time を選んだのに定期購入でカートに入る。
   *   B. DOM差し替えは checked "属性" しか更新しない。ラジオは一度でも JS から
   *      checkedness を書かれると dirty になり、以後 属性を変えても実際の選択状態
   *      （プロパティ）が追従しない。One-time を選ぶ操作で theme 自身がこれを起こすため、
   *      その後サブスクに戻しても画面は「Subscribe Now」なのにフォームは単品のまま。
   *      → サブスクのつもりが単品で購入される。
   */

  var SUBSCRIPTION_SELECTORS = '[data-subscription-selectors]';
  var PRODUCT_FORM_SELECTOR = 'form[data-product-form]';
  var SECTION_ID_SELECTOR = '[data-section-id]';
  var SECTION_API_SELECTOR = '[x-section-api]';

  // --- A対策: 商品セクションの再取得中だけ購入操作を止める -----------------------
  var BUSY_CLASS = 'section-render-pending';
  var STALE_ATTRIBUTE = 'data-purchase-selection-stale';
  var RENDER_TIMEOUT_MS = 10000;
  var ERROR_HIDE_MS = 5000;
  var renderStates = {};

  function findProductSection(sectionId, selector, attribute) {
    var sections = document.querySelectorAll(selector);
    for (var i = 0; i < sections.length; i++) {
      if (
        sections[i].getAttribute(attribute) === String(sectionId) &&
        sections[i].querySelector(SUBSCRIPTION_SELECTORS)
      ) {
        return sections[i];
      }
    }
    return null;
  }

  function getProductSection(sectionId) {
    if (!sectionId) return null;

    // 通常の商品セクションを優先し、data-section-id を持たないクイックビューは
    // x-section-api の描画境界へフォールバックする。
    return findProductSection(sectionId, SECTION_ID_SELECTOR, 'data-section-id') ||
      findProductSection(sectionId, SECTION_API_SELECTOR, 'x-section-api');
  }

  function setPurchaseControlsInert(section, isInert) {
    var controls = [
      section.querySelector(SUBSCRIPTION_SELECTORS),
      section.querySelector('.product__submit__buttons')
    ];

    for (var i = 0; i < controls.length; i++) {
      if (!controls[i]) continue;
      if (isInert) {
        controls[i].setAttribute('inert', '');
      } else {
        controls[i].removeAttribute('inert');
      }
    }
  }

  function setSectionBusy(section, isBusy) {
    section.classList.toggle(BUSY_CLASS, isBusy);
    setPurchaseControlsInert(section, isBusy);
    if (isBusy) {
      section.setAttribute('aria-busy', 'true');
    } else {
      section.removeAttribute('aria-busy');
    }
  }

  // --- B対策: サーバーが描いた checked 属性を実際の選択状態に反映させる ------------
  // 属性→プロパティを明示的に写して、サーバー描画を常に正とする。
  // プロパティを書いても属性は変わらないので、下の MutationObserver は再帰しない。
  function syncCheckedFromAttributes(root) {
    var queryRoot = root && root.querySelectorAll ? root : document;
    var radios = queryRoot.querySelectorAll(
      SUBSCRIPTION_SELECTORS + ' input[type="radio"]'
    );
    for (var i = 0; i < radios.length; i++) {
      var shouldBeChecked = radios[i].hasAttribute('checked');
      if (radios[i].checked !== shouldBeChecked) radios[i].checked = shouldBeChecked;
    }
  }

  // 差し替えのタイミングは fetch の解決より遅れることがあるため、
  // checked 属性が動いた瞬間にも反映する。
  new MutationObserver(function(records) {
    for (var i = 0; i < records.length; i++) {
      if (records[i].target.closest(SUBSCRIPTION_SELECTORS)) {
        syncCheckedFromAttributes();
        return;
      }
    }
  }).observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['checked']
  });

  function getProductForm(section) {
    return section && section.querySelector(PRODUCT_FORM_SELECTOR);
  }

  function handleSectionNavigate(event) {
    var sectionId = event.detail && event.detail.sectionId;
    var section = getProductSection(sectionId);
    if (!section) return;

    var previousState = renderStates[sectionId];
    if (previousState) {
      clearTimeout(previousState.completionTimer);
      clearTimeout(previousState.timeoutTimer);
    }

    section.removeAttribute(STALE_ATTRIBUTE);
    setSectionBusy(section, true);

    renderStates[sectionId] = {
      acceptsFollowingLoad: false,
      completionTimer: null,
      section: section,
      timeoutTimer: setTimeout(function() {
        var activeSection = renderStates[sectionId] ?
          renderStates[sectionId].section :
          section;
        setSectionBusy(activeSection, false);
        activeSection.setAttribute(STALE_ATTRIBUTE, '');
        showPurchaseSelectionError(getProductForm(activeSection), activeSection);
        delete renderStates[sectionId];
      }, RENDER_TIMEOUT_MS)
    };
  }

  function handleSectionLoad(event) {
    var sectionId = event.detail && event.detail.sectionId;
    var state = renderStates[sectionId];
    if (!state || !state.acceptsFollowingLoad) return;

    // cache-and-network は、キャッシュ描画の update の直後に load を発火する。
    // その場合は完了予約を取り消し、ネットワーク描画の update まで待つ。
    state.acceptsFollowingLoad = false;
    clearTimeout(state.completionTimer);
    state.completionTimer = null;
  }

  function handleSectionUpdate(event) {
    var sectionId = event.detail && event.detail.sectionId;
    var state = renderStates[sectionId];
    var section = getProductSection(sectionId);
    if (!state && !section) return;

    if (state) {
      var activeSection = section || state.section;
      if (state.section !== activeSection) setSectionBusy(state.section, false);
      state.section = activeSection;
      syncCheckedFromAttributes(activeSection);
      // morphはサーバーHTMLにないinert属性を除去するため、完了判定まで再適用する。
      setSectionBusy(activeSection, true);
      clearTimeout(state.completionTimer);
      // キャッシュ描画の直後に同一ターンで load が続く場合は、handleSectionLoad が
      // この予約を取り消す。最終描画なら次のターンで操作を戻す。
      state.acceptsFollowingLoad = true;
      Promise.resolve().then(function() {
        if (renderStates[sectionId] === state) {
          state.acceptsFollowingLoad = false;
        }
      });
      state.completionTimer = setTimeout(function() {
        clearTimeout(state.timeoutTimer);
        activeSection.removeAttribute(STALE_ATTRIBUTE);
        setSectionBusy(activeSection, false);
        delete renderStates[sectionId];
      }, 0);
      return;
    }

    // タイムアウト後に遅れて描画が完了した場合も、サーバー状態を正として復旧する。
    syncCheckedFromAttributes(section);
    section.removeAttribute(STALE_ATTRIBUTE);
    setSectionBusy(section, false);
  }

  window.addEventListener('theme:section:navigate', handleSectionNavigate);
  window.addEventListener('theme:section:load', handleSectionLoad);
  window.addEventListener('theme:section:update', handleSectionUpdate);

  // --- 送信契約: 表示ではなくフォーム値を最後に検証する ---------------------------
  function getPurchaseControls(form) {
    var controls = Array.prototype.slice.call(form.elements);
    var groups = controls.filter(function(control) {
      return control.name === 'selling-plan-group';
    });
    return {
      groups: groups,
      group: groups.filter(function(control) {
        return control.checked;
      })[0],
      plans: controls.filter(function(control) {
        return control.name === 'selling_plan';
      })
    };
  }

  function hasValidPurchaseSelection(form) {
    var controls = getPurchaseControls(form);
    if (controls.groups.length === 0) return true;
    if (!controls.group) return false;

    if (controls.group.value === '') {
      return controls.plans.every(function(plan) {
        return !plan.checked && plan.disabled;
      });
    }

    var activePlans = controls.plans.filter(function(plan) {
      return plan.checked && !plan.disabled;
    });
    return activePlans.length === 1;
  }

  function getPurchaseSection(form) {
    if (!form || !form.closest) return null;
    return form.closest(SECTION_ID_SELECTOR) ||
      form.closest(SECTION_API_SELECTOR);
  }

  function findPurchaseSelectionMessage(form, section) {
    var messageRoot = section;
    if (!messageRoot) messageRoot = getPurchaseSection(form);
    if (!messageRoot) return '';

    var selectors = messageRoot.querySelector(SUBSCRIPTION_SELECTORS);
    return selectors ?
      selectors.getAttribute('data-purchase-selection-error') || '' :
      '';
  }

  function getErrorDisplay(form) {
    if (!form) return null;
    var errorDisplay = form.querySelector('[data-error-display]');
    if (!errorDisplay) {
      var boundary = form.closest('[data-error-boundary]');
      if (boundary) errorDisplay = boundary.querySelector('[data-error-display]');
    }
    return errorDisplay;
  }

  function hidePurchaseSelectionError(form) {
    var errorDisplay = getErrorDisplay(form);
    if (!errorDisplay) return;

    clearTimeout(errorDisplay.purchaseSelectionErrorTimer);
    errorDisplay.style.display = 'none';
  }

  function showPurchaseSelectionError(form, section) {
    var errorDisplay = getErrorDisplay(form);
    var message = findPurchaseSelectionMessage(form, section);
    if (!errorDisplay || !message) return;

    clearTimeout(errorDisplay.purchaseSelectionErrorTimer);
    errorDisplay.textContent = message;
    errorDisplay.style.display = 'block';
    errorDisplay.purchaseSelectionErrorTimer = setTimeout(function() {
      errorDisplay.style.display = 'none';
    }, ERROR_HIDE_MS);
  }

  function isPurchaseSelectionPending(form) {
    var section = getPurchaseSection(form);
    return Boolean(
      section &&
      (
        section.classList.contains(BUSY_CLASS) ||
        section.hasAttribute(STALE_ATTRIBUTE)
      )
    );
  }

  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches(PRODUCT_FORM_SELECTOR)) return;
    if (!isPurchaseSelectionPending(form) && hasValidPurchaseSelection(form)) {
      hidePurchaseSelectionError(form);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    showPurchaseSelectionError(form);
  }, true);

  // --- 読み込み時の既定をサブスクにする -----------------------------------------
  /*
   * 初回表示（URLに selling_plan なし）はテーマ既定が One-time なので、
   * 最初のプランをURLに指定してページ全体を読み直す。ラジオの checked を直接変更しないため、
   * 表示とフォーム値が異なる中間状態を作らない。
   */
  function redirectToDefaultSubscription() {
    // URLで明示されている選択は尊重する。
    var url = new URL(window.location.href);
    if (url.searchParams.has('selling_plan')) return;
    if (url.pathname.indexOf('/products/') === -1) return;

    var firstPlan = document.querySelector(
      SUBSCRIPTION_SELECTORS + ' input[name="selling_plan"]'
    );
    if (!firstPlan || !firstPlan.value) return;

    url.searchParams.set('selling_plan', firstPlan.value);
    window.location.replace(url.toString());
  }

  redirectToDefaultSubscription();

  // Redirect to cart page immediately after adding to cart.
  // `theme:cart:popdown` fires (with bubbles:true) specifically on successful cart add,
  // just before the drawer would open. `theme:cart:change` was too broad — it fires
  // on any cart update (quantity change, page load, etc.).
  document.addEventListener('theme:cart:popdown', function() {
    window.location.href = '/cart';
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
